import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f4f0e4da&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f0e4da')) {
      api.createRecord('f4f0e4da', component.options)
    } else {
      api.reload('f4f0e4da', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f4f0e4da&", function () {
      api.rerender('f4f0e4da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27txQ2okAz1De/JS/comp/FavElement.vue"
export default component.exports